import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=5ff588bd&scoped=true&"
import script from "./Live.vue?vue&type=script&lang=js&"
export * from "./Live.vue?vue&type=script&lang=js&"
import style0 from "./Live.vue?vue&type=style&index=0&id=5ff588bd&scoped=true&lang=scss&"
import style1 from "./Live.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff588bd",
  null
  
)

export default component.exports